import { Factory } from 'fishery'
import faker from 'faker'

export default Factory.define<APIResponse.DME.MemberCard>(() => ({
  readableSize: faker.random.alphaNumeric(),
  fileName: faker.random.alphaNumeric(),
  createdAt: faker.date.past().toISOString(),
}))
